import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

type ComingSoonModalProps = {
  open: boolean;
  onClose: () => void;
};

export function ComingSoonModal({ open, onClose }: ComingSoonModalProps) {
  const { t } = useTranslation();
  const closeRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;
    closeRef.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal-backdrop"
      role="presentation"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="coming-soon-title"
      >
        <h2 id="coming-soon-title">{t('storeModal.title')}</h2>
        <p>{t('storeModal.body')}</p>
        <div className="modal-actions">
          <button
            ref={closeRef}
            type="button"
            className="btn-primary"
            onClick={onClose}
          >
            {t('storeModal.close')}
          </button>
        </div>
      </div>
    </div>
  );
}
